import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  TextField
} from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#202b42",
  color: "white",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  textAlign: "center"
};

const ModalConfirmacion = ({ open, onClose, onConfirm, mensaje }) => {
  const [observacion, setObservacion] = useState("");
  const [error, setError] = useState(false);

  const handleConfirm = () => {
    if (observacion.trim() === "") {
      setError(true);
      return;
    }
    onConfirm(observacion);
    setObservacion("");
    setError(false);
  };

  const handleClose = () => {
    setObservacion("");
    setError(false);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Typography variant="h6" gutterBottom>
          Confirmar Acción
        </Typography>
        <Typography sx={{ mb: 2 }}>{mensaje}</Typography>

        <TextField
          label="Observación"
          multiline
          rows={3}
          variant="filled"
          fullWidth
          value={observacion}
          onChange={(e) => {
            setObservacion(e.target.value);
            if (e.target.value.trim() !== "") setError(false);
          }}
          error={error}
          helperText={error ? "La observación es obligatoria" : ""}
          sx={{
            mb: 3,
            backgroundColor: "#2c3e50",
            borderRadius: 1,
            input: { color: "white" },
            textarea: { color: "white" },
            label: { color: "white" }
          }}
        />

        <Box display="flex" justifyContent="space-between">
          <Button variant="contained" color="error" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="contained" color="success" onClick={handleConfirm}>
            Confirmar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalConfirmacion;